import { Ban, CircleCheck } from 'lucide-react'
import type { ReactNode } from 'react'

import type { PlatformAccountSummary } from '@aeris/contracts'
import { Badge } from '@aeris/ui'

/**
 * Como uma conta da plataforma se anuncia — F154.
 *
 * Estava dentro de `routes/plataforma.tsx`, e saiu de lá quando a ficha da
 * conta passou a precisar do mesmo selo. Duas cópias divergiriam no primeiro
 * dia em que alguém mudasse o tom de "Suspensa".
 */

export const STATUS_LABELS = {
  active: 'Ativa',
  suspended: 'Suspensa',
  archived: 'Arquivada',
} as const

export const StatusBadge = ({
  status,
}: {
  status: PlatformAccountSummary['status']
}): ReactNode => {
  // Ícone junto do texto: status nunca é comunicado só por cor (docs/UI_UX.md).
  if (status === 'active')
    return (
      <Badge
        tone="success"
        icon={<CircleCheck aria-hidden="true" className="h-3 w-3" />}
      >
        {STATUS_LABELS.active}
      </Badge>
    )
  if (status === 'suspended')
    return (
      <Badge
        tone="warning"
        icon={<Ban aria-hidden="true" className="h-3 w-3" />}
      >
        {STATUS_LABELS.suspended}
      </Badge>
    )
  return <Badge tone="neutral">{STATUS_LABELS.archived}</Badge>
}
